<template>
  <div class="page-content">
    <img alt="card" :src="require('../assets/logo-transparent1.png')" width="300" height="300" />
    <div v-if="user.name">
      <game-button @clicked="logout()">{{ $t('home.change') }}</game-button>
    </div>
    <div v-else class="login-form">
      <h1>{{ $t('home.title') }}</h1>
      <div class="form-input form-space-margin">
        <form>
          <div class="form-text">
            <label for="username">{{ $t('home.username') }}</label>
            <input
              class="input-text"
              id="username"
              name="username"
              v-model="input.username"
              v-on:keydown.enter.native="login"
            />
          </div>
          <game-button @clicked="login()" :disabled="loginLaunched">{{ $t('home.play') }}</game-button>
        </form>
      </div>
      <h4>{{ $t('home.caption') }}</h4>
    </div>
  </div>
</template>

<script>
import { notify } from "@/event-bus";
import { mapState } from "vuex";
import GameButton from "./Button";

export default {
  name: "LoginForm",
  components: {
    GameButton
  },
  data() {
    return {
      input: {
        username: ""
      },
      loginLaunched: false
    };
  },
  computed: {
    ...mapState({
      user: state => {
        return state.user.user;
      },
      game: state => {
        return state.game;
      }
    })
  },
  methods: {
    login() {
      this.loginLaunched = true;
      if (this.input.username !== "") {
        const userData = {
          name: this.input.username
        };
        this.$store.dispatch("user/saveUser", userData).then(() => {
          this.loginLaunched = false;
        });
      } else {
        notify("A username must be present", "ERROR");
        this.loginLaunched = false;
      }
    },
    logout() {
      const userData = {
        userId: this.user.id
      };
      this.$store.dispatch("user/deleteUser", userData);
      window.Echo.channel("game-" + this.game.id)
        .stopListening("CardPlayedEvent")
        .stopListening("CardsReadyEvent")
        .stopListening("HandWinnerEvent")
        .stopListening("MatchFinishedEvent")
        .stopListening("GameDeletedEvent")
        .stopListening("UnlockGameEvent");
      this.$store.commit("call/resetCall");
      this.$store.commit("game/exit");
      this.$store.commit("chat/resetChat");
      this.$store.commit("results/resetResults");
    }
  }
};
</script>
<style>
.page-content {
  margin-bottom: 6em;
}
.login-form {
  width: 80%;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  margin: auto;
  margin-top: 2em;
  padding: 10px;
  margin-bottom: 1em;
  border: solid 3px darkslategrey;
}

@media all and (max-width: 450px) {
  .form-text {
    display: block !important;
  }
}
</style>
